import React, { memo } from 'react';

type Props = {
  company: string;
  brand: string;
  accent: string;
};

export const Shopfront = memo(({ company, brand, accent }: Props) => {
  const sign = company.trim().slice(0, 10).toUpperCase() || 'SHOP';

  return (
    <svg className="FreeTrial__Shopfront" viewBox="0 0 220 200" aria-hidden="true">
      <rect x="0" y="190" width="220" height="10" fill="#d4d4d8" />
      <rect x="14" y="20" width="192" height="171" fill="#fafafa" stroke="#19214d" strokeWidth="2.5" />
      <rect x="8" y="8" width="204" height="14" rx="3" fill="#19214d" />
      <rect x="34" y="32" width="152" height="30" rx="4" fill="#19214d" />
      <text
        x="110"
        y="52"
        textAnchor="middle"
        fontFamily="Inter, Arial, sans-serif"
        fontWeight="700"
        fontSize="12"
        letterSpacing="3"
        fill="#fafafa"
      >
        {sign}
      </text>
      {[0, 1, 2, 3, 4, 5, 6, 7].map((index) => (
        <g key={index}>
          <rect x={14 + index * 24} y="72" width="24" height="20" fill={index % 2 ? '#fafafa' : brand} />
          <path
            d={`M${14 + index * 24} 92a12 12 0 0 0 24 0Z`}
            fill={index % 2 ? '#fafafa' : brand}
            stroke="#19214d"
            strokeWidth="1.5"
          />
        </g>
      ))}
      <rect x="14" y="72" width="192" height="20" fill="none" stroke="#19214d" strokeWidth="2" />
      <rect x="26" y="110" width="104" height="74" fill="#e6efff" stroke="#19214d" strokeWidth="2" />
      <path d="M50 110v14M78 110v14M106 110v14" stroke="#19214d" strokeWidth="1.5" />
      <path d="M40 132a10 10 0 0 1 20 0ZM68 132a10 10 0 0 1 20 0ZM96 132a10 10 0 0 1 20 0Z" fill={brand} />
      <rect x="38" y="160" width="32" height="5" rx="2" fill="#19214d" />
      <path d="M54 165v19" stroke="#19214d" strokeWidth="2.5" />
      <rect x="86" y="160" width="32" height="5" rx="2" fill="#19214d" />
      <path d="M102 165v19" stroke="#19214d" strokeWidth="2.5" />
      <circle cx="54" cy="155" r="4" fill={accent} />
      <path d="M34 178l18-18M100 178l22-22" stroke="#ffffff" strokeWidth="3" strokeOpacity=".7" />
      <rect x="144" y="108" width="46" height="83" fill={accent} stroke="#19214d" strokeWidth="2" />
      <rect x="152" y="118" width="30" height="30" rx="3" fill="#e6efff" fillOpacity=".85" />
      <circle cx="183" cy="156" r="2.5" fill="#fafafa" />
    </svg>
  );
});
